import { SupabaseService } from "../../../server/supabase/base-supabase-service";

export class SupabaseManageDiscoverService extends SupabaseService<"manage_discover"> {
  table = "manage_discover" as const;
}
